/** Shared Button (design README "Button"): primary / secondary / ghost, 48px, visible focus. */
import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";

type Variant = "primary" | "secondary" | "ghost";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  fullWidth?: boolean;
  children: ReactNode;
}

// forwardRef so callers can manage focus (e.g. returning focus to a disclosure-menu trigger on
// Esc/close — WCAG 2.4.3).
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = "primary", fullWidth, className, children, type = "button", ...rest },
  ref,
) {
  const cls = ["td-btn", `td-btn--${variant}`, fullWidth ? "td-btn--full" : "", className ?? ""]
    .filter(Boolean)
    .join(" ");
  return (
    <button ref={ref} type={type} className={cls} {...rest}>
      {children}
    </button>
  );
});
